export default __webpack_public_path__ + "static/media/56-min.58e3c299.png";